/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from "react";

/** Common Components */
import MolGrid, { Column } from "@moltech/molui/molgrid";
import Buttons from "../../../../../../components/ui/button/Buttons";
import CardSection from "../../../../../../components/ui/card/CardSection";
import CustomCenterModel from "../../../../../../components/ui/customCenterModel/CustomCenterModel";

/** Services */
import ToastService from "../../../../../../services/toastService/ToastService";
import { format_Date } from "../../../../../../components/finalMolGrid/libs/formatDate";

/** Utilities */
import EditCommissionRates from "./features/EditCommissionRates";
import { AppIcons } from "../../../../../../data/appIcons";

/** RTK Query */
import { useDeleteCommissionRateMutation, useGetAllCommissionRateMutation } from "../../../../../../app/services/contractAPI";
import PropTypes from "prop-types";
import { ContractContext } from "../../../../../../utils/context/ContractContext";

const CommissionRates = (props) => {
  const gridRef = useRef();
  const { contractId } = useContext(ContractContext);
  const [gridData, setGridData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModelOpen, setIsModelOpen] = useState(false);

  const [getAllCommissionRate, {
    isSuccess: isAllCommissionRateFetched,
    data: AllCommissionRateData
  }] = useGetAllCommissionRateMutation();

  const [deleteCommissionRate, {
    isSuccess: isCommissionRateDeleted,
    data: deleteCommissionRateData
  }] = useDeleteCommissionRateMutation();

  useEffect(() => {
    getAllCommissionRate({
      plContractKey: contractId, plSalesRepKey: 0, pdtAsOfDate: null
    });
    debugger
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractId]);

  useEffect(() => {
    if (isAllCommissionRateFetched && AllCommissionRateData) {
      setGridData(AllCommissionRateData);
    }
  }, [isAllCommissionRateFetched, AllCommissionRateData]);

  useEffect(() => {
    if (isCommissionRateDeleted && deleteCommissionRateData) {
      if (deleteCommissionRateData) {
        ToastService.success(deleteCommissionRateData?.errorMessage);
        getAllCommissionRate({
          plContractKey: contractId, plSalesRepKey: 0, pdtAsOfDate: null
        });
      }
      else {
        ToastService.error("Something went wrong");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCommissionRateDeleted, deleteCommissionRateData, getAllCommissionRate]);

  const handalRowEditClick = (rowData) => {
    setSelectedRow(rowData);
    setIsModelOpen(true);
  }

  const handleCloseModel = () => {
    setIsModelOpen(false);
    setSelectedRow(null);
  };

  const handleSaveSuccess = async () => {
    await getAllCommissionRate({
      plContractKey: contractId,
      plSalesRepKey: 0,
      pdtAsOfDate: null
    });
    handleCloseModel();
  };


  const getCtxMenuItems = (row) => {
    if (!row) return [];
    return [
      {
        label: "Edit",
        command: () => handalRowEditClick(row)
      },
      {
        label: "Delete",
        command: () => {
          const req = {
            plContractKey: row.lContractKey,
            pdtEffectiveDate: format_Date(row.dtEffectiveDate)
          }
          deleteCommissionRate(req);
        }
      }
    ];
  };
  const handleAddClick = () => {
    setIsModelOpen(true);
    setSelectedRow(null);
  };
  const headerContent = () => {
    return (
      <div className="d-flex justify-content-end gap-3 export-icon">
        <Buttons
          buttonText="Add Commission Rate"
          onClick={handleAddClick}
          buttonTypeClassName="btn blue-btn"
          titleText="Unassign Selected Items"
        />
      </div>
    );
  };

  return (
    <div className="row gap-4">
      <div className="scrollable-grid col-12">
        <CardSection
          cardTitle={`Commission Rate`}
          customHeader={true}
          headerContent={headerContent()}
        >
          <MolGrid
            ref={gridRef}
            value={gridData}
            grouping
            expandableRowGroups={true}
            paginator={false}
            scrollable
            scrollHeight="flex"
            filterDisplay="row"
            sortMode="single"
            showGridlines
            resizableColumns
            ctxMenuItems={getCtxMenuItems}
          >
            <Column
              field="dtEffectiveDate"
              header="Effective Date"
              colType="datetime"
              format="mm/dd/yyyy"
              bodyStyle={{ textAlign: "Center" }}
              grouping
              sortable
            />
            <Column
              field="dtEndDate"
              header="End Uploaded"
              colType="datetime"
              format="mm/dd/yyyy"
              bodyStyle={{ textAlign: "Center" }}
              grouping
              sortable
            />
            <Column field="lSalesRepKey" header="Sales Rep" grouping sortable />
            <Column field="nCommissionRate" header="Commission Rate" colType="number" body={(rowData) => `${Number(rowData.nCommissionRate).toFixed(2)}%`}
             bodyStyle={{ textAlign: "left" }}
             grouping sortable />
          </MolGrid>
        </CardSection>
        <CustomCenterModel
          isOpen={isModelOpen}
          useCustomBg={true}
          modalTitle={selectedRow ? "Edit Commission Rate" : "Add Commission Rate"}
          contentClass="content-30"
          onClose={handleCloseModel}
          modalTitleIcon={AppIcons.AddIcon}
          className="commission-rate-center-model"
        >
          <EditCommissionRates rowData={selectedRow} commissionRateList={gridData} onSaveSuccess={handleSaveSuccess} />
        </CustomCenterModel>
      </div>
    </div>
  );
};
CommissionRates.propTypes = {
  contractId: PropTypes.number,
};
export default CommissionRates;
